// PDF.js worker configuration
// This file provides a local worker URL instead of using CDN

import { GlobalWorkerOptions } from 'pdfjs-dist';

// Use a static worker URL that points to the unbundled worker file
// The worker file is copied to the public directory
const workerUrl = '/pdf.worker.min.js';

GlobalWorkerOptions.workerSrc = workerUrl;

// Export the worker URL for use in Worker component
export { workerUrl };
